import * as actionTypes from './actionTypes';
import axios from '../../axios';
import {
    compare
} from '../helper';


export const saveChannels = () => {
    return (dispatch, getState) => {
        dispatch(saveChannelsStart());
        const postData = {
            domainID: getState().domain.activeDomain.id
        }
        axios.post("channel/getChannels", postData)
            .then(response => {
                dispatch(saveChannelsToState(response.data));
            })
    }
}

export const saveChannelsToState = (channels) => {
    return {
        type: actionTypes.SAVE_CHANNELS,
        channels: channels,
    }
}


export const changeChannelPagination = (offset) => {
    return {
        type: actionTypes.CHANGE_CHANNEL_PAGINATION,
        offset: offset,
    }
}

export const saveChannelsStart = () => {
    return {
        type: actionTypes.SAVE_CHANNELS_START,
    }
}

export const filterChannels = (payload) => {
    if (!payload) payload = {};


    return (dispatch, getState) => {
        payload.status = payload && payload.status ? payload.status : getState().channel.filters.status;
        payload.title = payload && payload.title ? payload.title : getState().channel.filters.title;
        payload.sort = payload && payload.sort ? payload.sort.value : getState().channel.filters.sort;
        let channels = getState().channel.channels;
        if (payload.status) {
            channels = channels.filter(channel => {
                return channel.isActive === (payload.status.value === 1)
            });
        }

        if (payload.title) {
            channels = channels.filter(channel => {
                return channel.title.toLowerCase().indexOf(payload.title.toLowerCase()) !== -1;
            });
        }

        console.log(channels);

        if (payload.sort) {
            switch (payload.sort) {
                case "videosCountAsc":
                    compare(channels, "videosCount", true);
                    break;
                case "videosCountDesc":
                    compare(channels, "videosCount", false);
                    break;
                case "popularPoint":
                    compare(channels, "popularPoint", false);
                    break;
                case "viewCount":
                    compare(channels, "viewCount", false);
                    break;
                case "subscriberCount":
                    compare(channels, "subscriberCount", false);
                    break;
                case "nameAsc":
                    compare(channels, "title", true);
                    break;
                case "nameDesc":
                    compare(channels, "title", false);
                    break;
                default:
                    compare(channels, "title", true);
                    break;
            }
        }

        dispatch(saveFilteredChannels(channels, payload));
    }
}

export const saveFilteredChannels = (channels, filters) => {
    return {
        type: actionTypes.SAVE_FILTERED_CHANNELS,
        channels: channels,
        filters: filters,
    }
}

export const resetAllChannelsFilters = () => {
    return {
        type: actionTypes.RESET_ALL_CHANNELS_FILTERS,
    }
}


export const changeChannelFiltersExpanded = (expanded) => {
    return {
        type: actionTypes.CHANGE_CHANNEL_FILTERS_EXPANDED,
        expanded: expanded,
    }
}